<!-- eslint-disable no-plusplus -->
<!-- eslint-disable comma-dangle -->
<script setup lang="ts">
import { useRouter, useRoute } from "vue-router";
import EventParticipant from "@/components/EventParticipant.vue";
import { storeToRefs } from "pinia";
import { useEventParticipantStore } from "@/store/EventParticipant";
import useDate from "@/modules/useDate";

const { formatISODate } = useDate();

const today = new Date();
today.setHours(0, 0, 0, 0);
const todayISO = formatISODate(today);
const route = useRoute();
const router = useRouter();
const eventId = route.params.id as string;

const { currentPokerRunEvent } = storeToRefs(useEventParticipantStore());

const handleModeChanged = (newMode: string) =>
  router.replace({ name: "Home", query: { showMode: newMode } });
</script>
<template>
  <AppEventContainer :key="`registeredevent-${eventId}`" :show-offline="true">
    <EventParticipant :event-id="eventId"></EventParticipant>
  </AppEventContainer>
</template>
